import React, { useState } from "react";
import PanelTemplate from "../../shares/PanelTemplate";
import ReturnBoxInside from "./ReturnBoxInside";

const ReturnedOrder = (props) => {
  return (
    <>
      <PanelTemplate sidebarActiveLink="returned-order">
        <div className="panel-main-header mt-10">
          <span>ثبت سفارش مرجوعی</span>
        </div>

        <ReturnBoxInside />
      </PanelTemplate>
    </>
  );
};

export default ReturnedOrder;
